
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7162/api/',
    //Live
    //apiUrl: 'https://inn-api.off-ease.com/api/',
    //TEST
    apiUrl: 'https://arun-api.solegaze.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

